import Vue from 'vue';
import HealthcheckProxy from '@/proxies/Healthcheck';
import * as types from './mutation-types';
import { ENGINE_STATUS_LOADING, ENGINE_STATUS_STOPPED } from '@/constants';

const getFormatEngineStatus = value => {
  if (typeof value === 'boolean') {
    return Number(value);
  }
  if (typeof value === 'string') {
    return ENGINE_STATUS_STOPPED;
  }
  return value;
};

export default {
  async initialize() {
    try {} catch (e) {
      Vue.router.push({
        name: Vue.$app.route.ERROR,
        params: { error: 'system_error' },
      });
    }
  },
  async getEngineStatus({ dispatch, getters }) {
    const rpcServerStatus = getters.rpcServerRunning;
    if (rpcServerStatus === ENGINE_STATUS_LOADING) {
      return;
    }

    const proxy = new HealthcheckProxy();
    try {
      const { restapi_rpc_server } = await proxy.run('status');
      const status = getFormatEngineStatus(restapi_rpc_server);
      dispatch('changeEngineStatus', status);
    } catch (e) {
      // TODO
    }
  },
  changeEngineStatus({ commit }, payload) {
    commit(types.RPC_SERVER_RUNNING, payload);
  },
  async startEngine({ dispatch }) {
    const proxy = new HealthcheckProxy();
    try {
      dispatch('changeEngineStatus', ENGINE_STATUS_LOADING);
      const { restapi_rpc_server } = await proxy.run('start');
      const status = getFormatEngineStatus(restapi_rpc_server);
      dispatch('changeEngineStatus', status);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_start_engine', { root: true });
    }
  },
  async stopEngine({ dispatch }) {
    const proxy = new HealthcheckProxy();
    try {
      dispatch('changeEngineStatus', ENGINE_STATUS_LOADING);
      const { restapi_rpc_server } = await proxy.run('stop');
      const status = getFormatEngineStatus(restapi_rpc_server);
      dispatch('changeEngineStatus', status);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_stop_engine', { root: true });
    }
  },
};
